// { icf: 0, min: 96, max: 100, color: '#9cd486' }, // Erfüllung voll erreicht
// { icf: 1, min: 76, max: 95, color: '#c7ed8b' }, // Erfüllung erheblich ausgeprägt
// { icf: 2, min: 51, max: 75, color: '#E8E596' }, // Erfüllung mäßig ausgeprägt
// { icf: 3, min: 5, max: 50, color: '#EEB27B' }, // Erfüllung leicht ausgeprägt
// { icf: 4, min: 0, max: 4, color: '#F4856D' }, // Erfüllung nicht vorhanden

/**
 * 

 */

export function tugToPercentErfuellung(seconds: number): number {
  if (seconds < 0) {
    return 100;
  } else if (seconds <= 7) {
    // ICF 0: 100%
    return 100;
  } else if (seconds < 10) {
    // ICF 0: 96% - 99% > diff 3%
    // seconds 7 - 9.9 > diff 3
    return 99 - ((seconds - 7) / 3) * 3;
  } else if (seconds < 20) {
    // ICF 1: 76% - 95% -> diff 19%
    // seconds 10 - 19.9 > diff 10
    return 95 - ((seconds - 10) / 10) * 19;
  } else if (seconds < 30) {
    // ICF 2: 51% - 75% > diff 24%
    // seconds 20 - 29.9 > diff 10
    return 75 - ((seconds - 20) / 10) * 24;
  } else if (seconds < 40) {
    // ICF 3: 5% - 50% -> div 45%
    // seconds 30 - 39.9 > diff 10
    return 50 - ((seconds - 30) / 10) * 45;
  } else if (seconds <= 43) {
    // ICF 3: 0% - 5% -> div 5%
    // seconds 40 - 43 > diff 3
    return 5 - ((seconds - 40) / 3) * 5;
  } else {
    // alles drüber: auch 0%
    return 0;
  }
}

export function tugToPercentSchaedigung(seconds: number): number {
  return 100 - tugToPercentErfuellung(seconds);
}

export function icfScore(percent: number): number {
  if (percent >= 96) {
    return 0;
  } else if (percent >= 76) {
    return 1;
  } else if (percent >= 51) {
    return 2;
  } else if (percent >= 5) {
    return 3;
  } else {
    return 4;
  }
}

export function displayTugResults(): void {
  for (let sec = 0; sec <= 65; sec += 0.5) {
    const percent = tugToPercentErfuellung(sec);
    const icf = icfScore(percent);
    console.log(`${sec} Sekunden -> ${percent.toFixed(2)}% -> ICF ${icf}`);
  }
}

/**
    0 Sekunden -> 100.00% -> ICF 0
    0.5 Sekunden -> 100.00% -> ICF 0
    1 Sekunden -> 100.00% -> ICF 0
    1.5 Sekunden -> 100.00% -> ICF 0
    2 Sekunden -> 100.00% -> ICF 0
    2.5 Sekunden -> 100.00% -> ICF 0
    3 Sekunden -> 100.00% -> ICF 0
    3.5 Sekunden -> 100.00% -> ICF 0
    4 Sekunden -> 100.00% -> ICF 0
    4.5 Sekunden -> 100.00% -> ICF 0
    5 Sekunden -> 100.00% -> ICF 0
    5.5 Sekunden -> 100.00% -> ICF 0
    6 Sekunden -> 100.00% -> ICF 0
    6.5 Sekunden -> 100.00% -> ICF 0
    7 Sekunden -> 100.00% -> ICF 0
    7.5 Sekunden -> 98.50% -> ICF 0
    8 Sekunden -> 98.00% -> ICF 0
    8.5 Sekunden -> 97.50% -> ICF 0
    9 Sekunden -> 97.00% -> ICF 0
    9.5 Sekunden -> 96.50% -> ICF 0
    10 Sekunden -> 95.00% -> ICF 1
    10.5 Sekunden -> 94.05% -> ICF 1
    11 Sekunden -> 93.10% -> ICF 1
    11.5 Sekunden -> 92.15% -> ICF 1
    12 Sekunden -> 91.20% -> ICF 1
    12.5 Sekunden -> 90.25% -> ICF 1
    13 Sekunden -> 89.30% -> ICF 1
    13.5 Sekunden -> 88.35% -> ICF 1
    14 Sekunden -> 87.40% -> ICF 1
    14.5 Sekunden -> 86.45% -> ICF 1
    15 Sekunden -> 85.50% -> ICF 1
    15.5 Sekunden -> 84.55% -> ICF 1
    16 Sekunden -> 83.60% -> ICF 1
    16.5 Sekunden -> 82.65% -> ICF 1
    17 Sekunden -> 81.70% -> ICF 1
    17.5 Sekunden -> 80.75% -> ICF 1
    18 Sekunden -> 79.80% -> ICF 1
    18.5 Sekunden -> 78.85% -> ICF 1
    19 Sekunden -> 77.90% -> ICF 1
    19.5 Sekunden -> 76.95% -> ICF 1
    20 Sekunden -> 75.00% -> ICF 2
    20.5 Sekunden -> 73.80% -> ICF 2
    21 Sekunden -> 72.60% -> ICF 2
    21.5 Sekunden -> 71.40% -> ICF 2
    22 Sekunden -> 70.20% -> ICF 2
    22.5 Sekunden -> 69.00% -> ICF 2
    23 Sekunden -> 67.80% -> ICF 2
    23.5 Sekunden -> 66.60% -> ICF 2
    24 Sekunden -> 65.40% -> ICF 2
    24.5 Sekunden -> 64.20% -> ICF 2
    25 Sekunden -> 63.00% -> ICF 2
    25.5 Sekunden -> 61.80% -> ICF 2
    26 Sekunden -> 60.60% -> ICF 2
    26.5 Sekunden -> 59.40% -> ICF 2
    27 Sekunden -> 58.20% -> ICF 2
    27.5 Sekunden -> 57.00% -> ICF 2
    28 Sekunden -> 55.80% -> ICF 2
    28.5 Sekunden -> 54.60% -> ICF 2
    29 Sekunden -> 53.40% -> ICF 2
    29.5 Sekunden -> 52.20% -> ICF 2
    30 Sekunden -> 50.00% -> ICF 3
    30.5 Sekunden -> 47.75% -> ICF 3
    31 Sekunden -> 45.50% -> ICF 3
    31.5 Sekunden -> 43.25% -> ICF 3
    32 Sekunden -> 41.00% -> ICF 3
    32.5 Sekunden -> 38.75% -> ICF 3
    33 Sekunden -> 36.50% -> ICF 3
    33.5 Sekunden -> 34.25% -> ICF 3
    34 Sekunden -> 32.00% -> ICF 3
    34.5 Sekunden -> 29.75% -> ICF 3
    35 Sekunden -> 27.50% -> ICF 3
    35.5 Sekunden -> 25.25% -> ICF 3
    36 Sekunden -> 23.00% -> ICF 3
    36.5 Sekunden -> 20.75% -> ICF 3
    37 Sekunden -> 18.50% -> ICF 3
    37.5 Sekunden -> 16.25% -> ICF 3
    38 Sekunden -> 14.00% -> ICF 3
    38.5 Sekunden -> 11.75% -> ICF 3
    39 Sekunden -> 9.50% -> ICF 3
    39.5 Sekunden -> 7.25% -> ICF 3
    40 Sekunden -> 5.00% -> ICF 3
    40.5 Sekunden -> 4.17% -> ICF 4
    41 Sekunden -> 3.33% -> ICF 4
    41.5 Sekunden -> 2.50% -> ICF 4
    42 Sekunden -> 1.67% -> ICF 4
    42.5 Sekunden -> 0.83% -> ICF 4
    43 Sekunden -> 0.00% -> ICF 4
    43.5 Sekunden -> 0.00% -> ICF 4
    44 Sekunden -> 0.00% -> ICF 4
    44.5 Sekunden -> 0.00% -> ICF 4
    45 Sekunden -> 0.00% -> ICF 4
    45.5 Sekunden -> 0.00% -> ICF 4
    46 Sekunden -> 0.00% -> ICF 4
    46.5 Sekunden -> 0.00% -> ICF 4
    47 Sekunden -> 0.00% -> ICF 4
    47.5 Sekunden -> 0.00% -> ICF 4
    48 Sekunden -> 0.00% -> ICF 4
    48.5 Sekunden -> 0.00% -> ICF 4
    49 Sekunden -> 0.00% -> ICF 4
    49.5 Sekunden -> 0.00% -> ICF 4
    50 Sekunden -> 0.00% -> ICF 4
    50.5 Sekunden -> 0.00% -> ICF 4
    51 Sekunden -> 0.00% -> ICF 4
    51.5 Sekunden -> 0.00% -> ICF 4
    52 Sekunden -> 0.00% -> ICF 4
    52.5 Sekunden -> 0.00% -> ICF 4
    53 Sekunden -> 0.00% -> ICF 4
    53.5 Sekunden -> 0.00% -> ICF 4
    54 Sekunden -> 0.00% -> ICF 4
    54.5 Sekunden -> 0.00% -> ICF 4
    55 Sekunden -> 0.00% -> ICF 4
    55.5 Sekunden -> 0.00% -> ICF 4
    56 Sekunden -> 0.00% -> ICF 4
    56.5 Sekunden -> 0.00% -> ICF 4
    57 Sekunden -> 0.00% -> ICF 4
    57.5 Sekunden -> 0.00% -> ICF 4
    58 Sekunden -> 0.00% -> ICF 4
    58.5 Sekunden -> 0.00% -> ICF 4
    59 Sekunden -> 0.00% -> ICF 4
    59.5 Sekunden -> 0.00% -> ICF 4
    60 Sekunden -> 0.00% -> ICF 4
    60.5 Sekunden -> 0.00% -> ICF 4
    61 Sekunden -> 0.00% -> ICF 4
    61.5 Sekunden -> 0.00% -> ICF 4
    62 Sekunden -> 0.00% -> ICF 4
    62.5 Sekunden -> 0.00% -> ICF 4
    63 Sekunden -> 0.00% -> ICF 4
    63.5 Sekunden -> 0.00% -> ICF 4
    64 Sekunden -> 0.00% -> ICF 4
    64.5 Sekunden -> 0.00% -> ICF 4
    65 Sekunden -> 0.00% -> ICF 4
 */
